import qs from 'qs';
import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';
import type { BlockArchetype, BlockType, UserBlock } from '../../models/block';
import { useParams } from 'react-router-dom';

type Props = {
  archived?: boolean;
  completed?: boolean;
  blockType?: BlockType;
  archetype?: BlockArchetype;
};

export const useUserBlocks = ({
  archived,
  completed,
  blockType,
  archetype,
}: Props = {}) => {
  const { patient: userId } = useParams();

  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchUserBlocks = async (): Promise<UserBlock[]> => {
    const queryStr = qs.stringify(
      { archived, completed, block_type: blockType, archetype },
      { addQueryPrefix: true }
    );

    return await api({
      route: `/private/user/blocks/${queryStr}`,
      token: userToken,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Coach-Override': userId ?? '',
      },
    });
  };

  const { data, isLoading, isError } = useQuery<UserBlock[], Error>({
    queryKey: [
      'user-blocks',
      userToken,
      userId,
      archived,
      completed,
      blockType,
      archetype,
    ],
    queryFn: fetchUserBlocks,
    enabled: !!userId && isAuthenticated && !loading && !!userToken,
    refetchOnWindowFocus: false,
  });

  return {
    blocks: data ?? [],
    isLoading,
    isError,
  };
};
